import actionCreator from './action-creator';
import stateReducers from './state-reducers';
import stateSelectors from './state-selectors';
import actionTypes from './action-types';
import offer from './offer';
import customizeOffers from './customize-offers';

export default {
    actionCreator,
    actionTypes,
    stateReducers,
    stateSelectors,
    offer,
    customizeOffers,
};
